<template>
  <div class="news_and_announcement" :class="_.get(getConf, 'conf.0')">
    <div
      class="Inner"
      :class="{ container: _.get(getConf, 'conf.0') !== 'lay2' }"
    >
      <div class="box">
        <p class="title font-55 f-light">{{ _.get(getWidgetData, "title") }}</p>
        <a
          v-if="!_.get(getWidgetData, 'link.targetblank')"
          :href="_.get(getWidgetData, 'link.url')"
        >
          <button class="font-16 f-bold pointer">
            {{ _.get(getWidgetData, "link.title") }}
          </button>
        </a>
        <a
          v-if="_.get(getWidgetData, 'link.targetblank')"
          target="_blank"
          :href="_.get(getWidgetData, 'link.url')"
        >
          <button class="font-16 f-bold pointer">
            {{ _.get(getWidgetData, "link.title") }}
          </button>
        </a>
      </div>
      <div class="box">
        <div class="inner bn">
          <div
            class="top-cont"
            :class="{
              'container-2': _.get(getConf, 'conf.0') === 'lay2',
              container: _.get(getConf, 'conf.0') !== 'lay2'
            }"
          >
            <p
              v-if="_.get(getConf, 'header.title') === null"
              class="title font-34 f-roman"
            >
              {{ $fn.tr("News & Announcement ") }}
            </p>
            <p
              v-if="_.get(getConf, 'header.title') !== null"
              class="title font-34 f-roman"
            >
              {{ _.get(getConf, "header.title") }}
            </p>
            <div
              style="width: 40px; height: 40px; display: flex; justify-content: center; align-items: center; cursor: pointer;"
              @click="newsLink"
            >
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14.841"
                  viewBox="0 0 14 14.841"
                >
                  <path
                    id="Icon_ionic-md-arrow-round-back"
                    data-name="Icon ionic-md-arrow-round-back"
                    d="M6.911,11.98h9.025l-3.5-3.349a1.4,1.4,0,0,1,0-1.906,1.247,1.247,0,0,1,1.822,0l5.829,5.651a1.285,1.285,0,0,1,.38.945v.017a1.285,1.285,0,0,1-.38.945l-5.824,5.651a1.247,1.247,0,0,1-1.822,0,1.4,1.4,0,0,1,0-1.906l3.5-3.349H6.916a1.32,1.32,0,0,1-1.291-1.35A1.306,1.306,0,0,1,6.911,11.98Z"
                    transform="translate(20.33 -5.625) rotate(90)"
                    fill="#db504a"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div
          class="content"
          :class="{
            'container-2': _.get(getConf, 'conf.0') === 'lay2',
            container: _.get(getConf, 'conf.0') !== 'lay2'
          }"
        >
          <div class="inner">
            <newsItem
              v-for="(item, index) in getData"
              :key="index"
              :item="item"
            />
          </div>
        </div>
        <div class="container-2 explore-button">
          <div  @click="newsLink">
            <button class="explore">
              {{ _.get(getConf, "header.full_list_title") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import newsItem from "../list/news_and_announcement_item.vue";
import Main from "@/mixins/main";
export default {
  mixins: [Main],
  props: ["contentData"],
  components: {
    newsItem
  },
  data() {
    return {};
  },
  watch: {
    locale: {
      immediate: true,
      handler: function() {
        if (this.locale === "ge") {
          moment.locale("ka");
        } else {
          moment.locale("en");
        }
      }
    }
  },
  methods: {
    newsLink() {
      if(this.category){
                
          let fullUrl = _.get(this.epicNews, "full_url");


        if (fullUrl.includes('?')) {

          fullUrl += `&category=${encodeURIComponent(this.category)}`;
        } else {

          fullUrl += `?category=${encodeURIComponent(this.category)}`;
        }

        // Redirect to the new URL
        window.location = fullUrl;
      }else{
        window.location = _.get(this.epicNews, "full_url");
      }
     
    }
  },
  computed: {
    epicNews() {
      let newsData = this.getMenuFlat("footer", 0).find(el => el.url === "news")
        .id;
      for (var i = 0; i < this.getMenuFlat("footer", 0).length; i++) {
        if (this.getMenuFlat("footer", 0)[i]?.id === newsData) {
          return this.getMenuFlat("footer", 0)[i];
        }
      }
    },
    locale() { 
      return _.get(this.$store, "state.main.indx.locale");
    },
    getConf() {
      return _.get(this.contentData, "conf");
    },
    getData() {
      return _.get(this.contentData, "data.list");
    },
    getWidgetData() {
      return _.get(this.$store.state.main, "indx.widgets.powerful_message");
    },
    categories(){
      return _.get(this.$store, 'state.main.indx.terms.announce_category')
    },
    category(){
      const tmp = _.get(this.getConf, "taxonomies.announce_category.0");
      if(!tmp) return null
      return this.categories.find(item => item.id === tmp)?.slug; 
    },
  
  }
};
</script>

<style lang="scss">
body.white .news_and_announcement button {
  text-decoration: underline;
}
body.yellow .news_and_announcement .box:nth-child(2) {
  .content {
    border-left: none !important;
  }
  .item {
    border-bottom: 1px solid #0d1317 !important;
  }
}
body.black .news_and_announcement .box:nth-child(2) {
  .content {
    border-left: 1px none !important;
  }
  .item {
    border-bottom: 1px solid #373c3f !important;
  }
}
.news_and_announcement {
  .explore-button {
    @media (max-width: 1023px) {
      padding: 0;
    }
  }
  .explore {
    cursor: pointer;
    margin-bottom: 50px;
    display: none !important;
    @include defBut(
      var(--primay-button-bg),
      var(--bonus-txt3),
      var(--secondarty-transparent),
      var(--white-button-txt2)
    );
  }
  &.lay2 {
    display: unset;
    .Inner {
      margin-top: 55px;
      @media (max-width: 767px) {
        margin-top: 0px;
      }
    }
    .explore {
      display: flex !important;
    }
    .box:nth-child(1) {
      display: none;
    }
    .box:nth-child(2) {
      margin-right: 0px !important;
      margin-top: 0px !important;
      width: 100% !important;
      .inner {
        padding-left: 0px !important;
        padding-right: 0px !important;
        margin-bottom: 50px;
        //
        @media (max-width: 1023px) {
          padding-top: 20px !important;
        }
        padding-top: 0px !important;
        &.bn {
          @media (min-width: 1024px) {
            background-color: var(--white-transparent);
          }
          margin-bottom: 0;
        }
      }
      .content {
        border-left: none !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
        .inner {
          display: flex;
          flex-wrap: wrap;
          flex-direction: unset !important;
          @media (max-width: 767px) {
            flex-direction: column !important;
          }
          .item {
            width: calc(50% - 30px);
            border-bottom: 1px solid var(--bonus-txt) !important;
            position: relative;
            height: 140px;
            .date {
              position: absolute;
              top: 40px;
            }
            .title {
              display: -webkit-box !important;
            }
            &:nth-child(1n) {
              margin-right: 15px;
              @media (max-width: 767px) {
                margin-right: 0px;
              }
            }
            &:nth-child(2n) {
              margin-left: 15px;
              @media (max-width: 767px) {
                margin-left: 0px;
              }
            }
            @media (max-width: 767px) {
              width: 100%;
            }
          }
        }
      }
      .top-cont {
        justify-content: unset !important;
        @media (max-width: 1023px) {
          padding: 0;
        }
        .title {
          margin-right: 20px;
        }
      }
    }
  }
  background: var(--gray-bg);
  display: flex;
  justify-content: flex-end;
  @media (max-width: 1679px) {
    justify-content: unset;
  }
  // padding-bottom: 30px;
  &.fade-up.in-viewport {
    opacity: 1;
    transform: translateY(0px);
  }
  .Inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // width: 1315px;
    // margin-right: 36px;
    // padding-left: 20px;
    // @media (max-width: 1679px) {
    //     width: 1104px;
    // }
    // @media (max-width: 1439px) {
    //     width: 1043px;
    // }
    &.container:not(.news_and_announcement.lay2 .Inner.container) {
      @media (min-width: 1024px) {
        margin: 0 36px;
        width: unset;
      }
      @media (max-width: 1365px) {
        padding-left: 0px;
        padding-right: 0px;
      }
    }
    @media (max-width: 1023px) {
      flex-direction: column-reverse;
      // margin-right: 0px;
      // padding-left: 0px;
      &.container {
        width: 100%;
        padding: 0;
      }
    }
    .box {
      &:nth-child(1) {
        // width: 42%;
        width: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: calc(50% - 570px);
        margin-right: 30px;

        @media (max-width: 1023px) {
          width: unset;
          background-color: var(--white-bg);
          padding-top: 144px;
          padding-left: 15px;
          padding-right: 15px;
          padding-bottom: 144px;
          margin-right: 0px;
        }
        @media (max-width: 767px) {
          padding-left: 20px;
          padding-right: 20px;
          padding-top: 30px;
          padding-bottom: 90px;
          width: 100%;
        }
        .title {
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          // -webkit-line-clamp: 3;
          font-size: 34px;
          color: var(--white-no-blue2);
          // @media (max-width: 1365px) {
          //   font-size: 34px;
          // }
          @media (max-width: 1279px) {
            font-size: 21px;
          }
          @media (max-width: 1023px) {
            // font-size: 34px;
            // -webkit-line-clamp: 4;
          }
          // @media (max-width: 374px) {
          //   font-size: 21px;
          // }
        }
        a {
          margin-top: 40px;
        }
        button {
          @include defBut(
            var(--primay-button-bg),
            var(--bonus-txt3),
            var(--secondarty-transparent),
            var(--white-button-txt2)
          );
        }
      }
      &:nth-child(2) {
        width: 713px;
        background-color: var(--gray-bg);
        margin-top: -80px;
        position: relative;
        margin-right: 30px;
        z-index: 9;
        @media (max-width: 1900px) {
          width: 600px;
        }
        @media (max-width: 1679px) {
          width: 522px;
        }
        @media (max-width: 1439px) {
          width: 493px;
        }
        @media (max-width: 1365px) {
          width: 382px;
        }
        @media (max-width: 1023px) {
          width: 100%;
          margin-top: 0px;
          margin-right: 0px;
        }
        @media (max-width: 1023px) {
          // background-color: var(--white-bg);
          padding-left: 20px;
          padding-right: 20px;
        }
        @media (max-width: 767px) {
          background-color: var(--white-bg);
        }
        .inner:not(.content .inner) {
          padding-left: 35px;
          padding-right: 35px;
          padding-top: 20px;
          @media (max-width: 1023px) {
            padding-left: 0px;
            padding-right: 0px;
          }
          @media (max-width: 767px) {
            padding-top: 28px;
          }
        }
        .top-cont {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          border-bottom: 1px solid var(--red);
          padding-bottom: 18px;
          padding-left: 0px;
          padding-right: 0px;
          @media (max-width: 767px) {
            padding-bottom: 28px;
          }
          .title {
            color: var(--white-no-blue2);
            @media (max-width: 1365px) {
              font-size: 21px;
            }
            @media (max-width: 1023px) {
              font-size: 34px;
            }
            @media (max-width: 767px) {
              font-size: 21px;
            }
          }
        }
        .content {
          padding-left: 35px;
          padding-right: 35px;
          border-left: 1px solid #c8c9ca;
          width: unset;
          @media (max-width: 1679px) {
            width: 100%;
          }
          @media (max-width: 1023px) {
            border-left: none;
            padding-left: 0px;
            padding-right: 0px;
          }
          .inner {
            flex-direction: column;
            .item {
              &:last-child {
                border-bottom: none;
                @media (max-width: 767px) {
                  border-bottom: 1px solid #c8c9ca;
                }
              }
              border-bottom: 1px solid #c8c9ca;
              padding-bottom: 55px;
              margin-top: 50px;
              @media (max-width: 767px) {
                margin-top: 21px;
                padding-bottom: 16px;
              }
              .title {
                color: var(--bonus-txt);
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                @media (max-width: 767px) {
                  font-size: 16px;
                }
              }
              .date {
                color: var(--red-txt);
                margin-top: 20px;
                @media (max-width: 767px) {
                  margin-top: 18px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
